import { FC } from 'react';
import { socialLukeState } from './social-luke.state';
import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';
import PreviewSection from '@components/shared/preview-section/preview-section';
import SectionDescription from '@components/shared/section-description/section-description';
import FAQSection from '@components/shared/blocks/faq';
import SharedAnimation from '@components/shared/animation';
import animations from '@components/shared/animation/animations.module.scss';
import ServiceCards from '@components/shared/service-cards/service-cards';
import ChessOrderSection from '@components/shared/chess-order-section/chess-order-section';
import QuoteSection from '@components/shared/quote-section/quote-section';
import Collaborations from '@components/projects/social-luke/sections/collaborations/collaborations';
import TechnologyStack from '@components/projects/social-luke/sections/technology-stack/technology-stack';
import styles from './social-luke.module.scss';
import { Themes } from '@layouts/main-layout/themes.enum';
interface SocialLukeComponentProps {
  breadcrumbsText: string;
}

const SocialLukeComponent: FC<SocialLukeComponentProps> = ({ breadcrumbsText }) => {
  const { preview, unique, faq, services, keyFeatures, feedback, collaborations, technologyStack } = socialLukeState;

  return (
    <>
      <Breadcrumbs lastElementTitle={breadcrumbsText} theme={Themes.DarkGray} />
      <PreviewSection preview={preview} isDifferentColor={true} isCustomzePhoto={true} />
      <SectionDescription section={unique} />
      <Collaborations collaborations={collaborations} />
      <SharedAnimation
        render={(ref) => (
          <div ref={ref} className={`${styles.containerDifferent} ${animations.scroll__animation}`}>
            <FAQSection title={faq.title} itemsFAQ={faq.items} hoverColor={'grey'} />
          </div>
        )}
      />
      <ServiceCards section={services} />
      <TechnologyStack technologyStack={technologyStack} />
      <ChessOrderSection section={keyFeatures} />
      <QuoteSection section={feedback} isDifferentColor={true} />
    </>
  );
};

export default SocialLukeComponent;
